export default __webpack_public_path__ + "static/media/starRoundGolden.d64c6e5e.svg";